<template>
  <div :class="classes" @click="$emit('click')">
    <div :class="$style.wrapper">
      <div :class="$style.back"></div>
      <div :class="$style.front" :style="`background-image: url(${face})`"></div>
    </div>
  </div>
</template>
<script>
import classes from '@/utils/classes'

export default {
  name: 'Card',
  props: {
    face: String,
    up: Boolean,
    animation: Boolean,
  },
  computed: {
    classes() {
      const { $style, up, animation } = this
      return classes($style.card, up && $style.up, animation && $style.animation)
    },
  },
}
</script>
<style lang="scss" module>
@import './Card.scss';
</style>
